import React, { useCallback, useEffect, useState } from "react";

import { AdminScreen, Field, Section } from "@/admin/kit";
import { api } from "@/lib/api";
import { Button } from "@/components/kit";
import { useApp } from "@/store";

export default function AdminUsers() {
  const { toast, user } = useApp();
  const [q, setQ] = useState("");
  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState("");
  const [audit, setAudit] = useState([]);
  const load = useCallback(() => {
    api(`/admin/users?q=${encodeURIComponent(q)}`).then(setUsers).catch((e) => toast(e.message, "error"));
    api("/admin/audit").then(setAudit).catch(() => {});
  }, [q, toast]);
  useEffect(() => {
    const t = setTimeout(load, 200);
    return () => clearTimeout(t);
  }, [load]);
  const setRole = async (em, role) => {
    try {
      await api("/admin/users/role", { method: "POST", body: { email: em, role } });
      toast(`${em} is now ${role}.`, "success");
      setEmail("");
      load();
    } catch (e) {
      toast(e.message, "error");
    }
  };
  return (
    <AdminScreen title="Admins & recent changes" testId="admin-users">
      <div className="grid items-start gap-5 md:grid-cols-2">
        <Section title="Roles" note="Admins have full access. You can't remove the last admin." testId="admin-roles">
          <div className="flex items-end gap-2">
            <div className="flex-1"><Field testId="admin-role-email" label="Promote by email" value={email} onChange={setEmail} placeholder="name@example.com" type="email" /></div>
            <Button testId="admin-role-promote" title="Make admin" disabled={!email.includes("@")} onClick={() => setRole(email.trim(), "admin")} className="!min-h-[44px] !px-4" />
          </div>
          <Field testId="admin-users-search" label="Search users" value={q} onChange={setQ} />
          {users.map((u, i) => (
            <div key={u.id} data-testid={`admin-user-${i}`} className="flex items-center gap-2 rounded-xl bg-white p-2.5">
              <div className="min-w-0 flex-1">
                <p className="t-strong truncate">{u.email}{u.id === user?.id ? " (you)" : ""}</p>
                <p className="t-caption">{u.role}</p>
              </div>
              <Button testId={`admin-user-${i}-toggle`} title={u.role === "admin" ? "Demote" : "Make admin"} variant="outline" onClick={() => setRole(u.email, u.role === "admin" ? "user" : "admin")} className="!min-h-[44px] !px-4" />
            </div>
          ))}
        </Section>
        <Section title="Recent changes" testId="admin-audit">
          {audit.length ? audit.slice(0, 50).map((a, i) => (
            <div key={i} data-testid={`admin-audit-${i}`} className="border-b border-divider py-1.5">
              <p className="t-strong">{a.action} · {a.entity}{a.entity_id ? ` · ${a.entity_id}` : ""}</p>
              <p className="t-caption">{a.admin_email} (id {(a.admin_id ?? "").slice(-6)}) · {new Date(a.ts).toLocaleString()}</p>
            </div>
          )) : <p className="t-caption">No changes yet.</p>}
        </Section>
      </div>
    </AdminScreen>
  );
}
